export class StringUtils {
    public static normalizarTexto(texto: string): string {
        if (this.isNullOrEmpty(texto))
            return "";

        return texto.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    public static isNullOrEmpty(val: string): boolean {
        if (val === undefined || val === null || val.trim() === '') {
            return true;
        }
        return false;
    }
}